import React from 'react';
import './styles.scss';

export interface ITableProps {
  style?: object,
  className?: string
}

const Table: React.FC<ITableProps> = ({children, style = {}, className}) => {
  return (
    <div className={`table-container${className ? ` ${className}` : ''}`} style={style}>
      <div className="table">
        {children}
      </div>
    </div>
  );
};

export default Table;
